import { Component, OnInit } from '@angular/core';
import { AppMonitoringService } from './services/logging.service';
import { SitesService } from './services/sites.service';
import { LoadingService } from './shared/loader/LoadingService';
import { delay } from 'rxjs';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
	title = 'BeachWatch';
	loading : boolean = false;

	constructor(private azAppInsightService: AppMonitoringService,
		private sitesService : SitesService,
		private loadingService : LoadingService)
	{
		this.sitesService.populateSites();
	}

	ngOnInit(): void {
		this.azAppInsightService.logPageView("BeachWatch", window.location.href);
		this.listenToLoading();
	}
	
	private listenToLoading = () => 
	{
		this.loadingService.loadingSub.pipe(delay(0)).subscribe((loading) => {
			this.loading = loading;		
		});
	}
}
